<template>
  <svg
    width="174"
    height="195"
    viewBox="0 0 174 195"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="86.5116" cy="99.4882" r="86.5116" fill="#E0E0E0" />
    <path
      d="M132.998 30.0183C132.143 29.7702 131.651 28.8761 131.899 28.021L133.453 22.6607C134.929 17.5738 131.991 12.2353 126.904 10.76C121.817 9.2846 116.479 12.2229 115.003 17.3095C114.755 18.1647 113.861 18.6567 113.006 18.4087C112.151 18.1606 111.659 17.2666 111.907 16.4114C113.877 9.61714 121.008 5.6929 127.802 7.66346C134.596 9.63401 138.52 16.7645 136.55 23.5587L134.995 28.919C134.747 29.7743 133.853 30.2663 132.998 30.0183Z"
      fill="#FF5252"
    />
    <g filter="url(#filter0_ddd)">
      <path
        d="M36.3804 162.643H136.643C140.271 162.643 143.212 159.702 143.212 156.074V32.0259C143.212 28.3979 140.271 25.457 136.643 25.457H36.3804C32.7524 25.457 29.8115 28.3979 29.8115 32.0259V156.074C29.8115 159.702 32.7527 162.643 36.3804 162.643Z"
        fill="white"
      />
    </g>
    <path
      d="M112.041 53.1657C106.55 51.5733 103.379 45.8108 104.972 40.3206L111.907 16.4089C112.155 15.5536 113.049 15.0616 113.904 15.3097C114.759 15.5577 115.251 16.4517 115.003 17.307L108.068 41.2185C106.971 45.0015 109.156 48.9718 112.939 50.069C116.722 51.1662 120.692 48.9811 121.789 45.1981L128.724 21.2866C129.443 18.8073 128.012 16.2056 125.532 15.4865C123.053 14.7675 120.451 16.1995 119.732 18.6786L115.451 33.4411C115.203 34.2964 114.308 34.7883 113.453 34.5403C112.598 34.2923 112.106 33.3983 112.354 32.5431L116.636 17.7805C117.85 13.5941 122.244 11.1759 126.43 12.3901C130.617 13.6043 133.035 17.9982 131.821 22.1846L124.886 46.0962C123.293 51.5866 117.531 54.7581 112.041 53.1657Z"
      fill="#FF5252"
    />
    <path
      d="M120.344 105.656H52.5592C51.2431 105.656 50.1768 104.589 50.1768 103.273C50.1768 101.957 51.2431 100.891 52.5592 100.891H120.344C121.66 100.891 122.726 101.957 122.726 103.273C122.726 104.589 121.66 105.656 120.344 105.656Z"
      fill="#FF5252"
    />
    <path
      d="M96.3143 121.3H52.5592C51.2431 121.3 50.1768 120.233 50.1768 118.918C50.1768 117.602 51.2431 116.535 52.5592 116.535H96.3143C97.6301 116.535 98.6968 117.602 98.6968 118.918C98.6968 120.233 97.6301 121.3 96.3143 121.3Z"
      fill="#404B58"
    />
    <path
      d="M106.638 136.949H52.5592C51.2431 136.949 50.1768 135.882 50.1768 134.566C50.1768 133.25 51.2431 132.184 52.5592 132.184H106.638C107.954 132.184 109.021 133.25 109.021 134.566C109.021 135.882 107.954 136.949 106.638 136.949Z"
      fill="#404B58"
    />
    <path
      d="M59.3824 82.9962C58.0664 82.9962 57 81.9298 57 80.6137V75.9371C57 74.6211 58.0664 73.5547 59.3824 73.5547C60.6985 73.5547 61.7649 74.6211 61.7649 75.9371V80.6137C61.7649 81.9295 60.6988 82.9962 59.3824 82.9962Z"
      fill="#404B58"
    />
    <path
      d="M115.198 82.9962C113.882 82.9962 112.816 81.9298 112.816 80.6137V75.9371C112.816 74.6211 113.882 73.5547 115.198 73.5547C116.514 73.5547 117.581 74.6211 117.581 75.9371V80.6137C117.581 81.9295 116.514 82.9962 115.198 82.9962Z"
      fill="#404B58"
    />
    <path
      d="M87.4344 78.4374C90.9697 78.4374 94.3315 79.9685 96.6577 82.6382C97.5224 83.6302 97.4188 85.1353 96.4268 85.9996C95.4344 86.864 93.9303 86.7607 93.0653 85.7687C91.6441 84.1375 89.5917 83.2023 87.4341 83.2023C85.2766 83.2023 83.2242 84.1375 81.803 85.7687C80.9389 86.7604 79.4339 86.864 78.4415 85.9996C77.4498 85.1353 77.3462 83.6302 78.2106 82.6381C80.5374 79.9689 83.8992 78.4374 87.4344 78.4374Z"
      fill="#404B58"
    />
    <circle cx="144" cy="167" r="28" fill="#FF5252" />
    <path
      d="M130 167.996C130 172.36 130 176.709 130 181.073C130 181.582 130.449 182 130.959 182C138.867 182 146.775 182 154.683 182C155.797 182 156.926 182 158.041 182C158.567 182 159 181.567 159 181.073C159 176.709 159 172.36 159 167.996C159 166.8 157.066 166.786 157.066 167.996C157.066 172.36 157.066 176.709 157.066 181.073C157.391 180.76 157.716 180.446 158.025 180.147C150.117 180.147 142.21 180.147 134.302 180.147C133.188 180.147 132.058 180.147 130.944 180.147C131.269 180.461 131.594 180.775 131.903 181.073C131.903 176.709 131.903 172.36 131.903 167.996C131.95 166.8 130 166.8 130 167.996Z"
      fill="white"
    />
    <path
      d="M143.557 153.902C143.557 158.849 143.557 163.796 143.557 168.728C143.557 169.431 143.557 170.133 143.557 170.821C143.557 172.016 145.491 172.031 145.491 170.821C145.491 165.874 145.491 160.927 145.491 155.995C145.491 155.292 145.491 154.59 145.491 153.902C145.476 152.707 143.557 152.692 143.557 153.902Z"
      fill="white"
    />
    <path
      d="M136.144 164.648C138.713 166.935 141.266 169.206 143.835 171.493C144.237 171.852 144.81 171.852 145.197 171.493C147.75 169.221 150.304 166.95 152.872 164.678C153.785 163.856 152.424 162.541 151.511 163.363C148.957 165.634 146.404 167.906 143.835 170.178C144.284 170.178 144.748 170.178 145.197 170.178C142.628 167.891 140.075 165.619 137.506 163.333C136.608 162.511 135.231 163.841 136.144 164.648Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_ddd"
        x="7.81152"
        y="8.45703"
        width="157.4"
        height="183.186"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="7" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="5" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow"
          result="effect2_dropShadow"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="12" />
        <feGaussianBlur stdDeviation="8.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow"
          result="effect3_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</template>
<script>
export default {
  name: 'DownloadExpiredSVG'
}
</script>
